import { z } from "zod";
import { objectIdSchema } from "./common";
export const planFeatureEnum = z.enum([
    "webhooks",
    "campaigns",
    "contact_import",
    "api_access",
    "multi_device",
]);
export const planSchema = z.object({
    _id: objectIdSchema,
    name: z.string().min(1).max(60),
    dailyLimit: z.number().int().min(1),
    monthlyLimit: z.number().int().min(1),
    maxDevices: z.number().int().min(1),
    maxApiKeys: z.number().int().min(1),
    features: z.array(planFeatureEnum).default([]),
});
/** Default plan seeded for every new user; admins can override per-user via /admin/*. */
export const DEFAULT_PLAN = {
    name: "Free",
    dailyLimit: 100,
    monthlyLimit: 2000,
    maxDevices: 2,
    maxApiKeys: 3,
    features: ["webhooks", "contact_import", "api_access"],
};
//# sourceMappingURL=plan.js.map